import ReportDeliveryOrder from "../../../../components/@reports/sales/ReportDeliveryOrder";

import { ReportContextProvider } from "../../../../context/ReportContext";

import { reportScopes, reportTypes } from "../../../../hooks/api/useReports";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

import { validationSchema, initialValues, advancedValidationSchema, advancedInitialValues } from "../../../../schema/reports/sales/deliveryOrderSchema"

export default function DeliveryOrderReport() {

    let routeType = routeTypes.admin

    return (
        <ReportContextProvider
            routeType={routeType}
            reportScope={reportScopes.sales}
            reportType={reportTypes.sales.deliveryOrder.id}
            validationSchema={validationSchema}
            advancedValidationSchema={advancedValidationSchema}
            initialValues={initialValues}
            advancedInitialValues={advancedInitialValues}
        >
            <ReportDeliveryOrder
                routeType={routeType}
            />
        </ReportContextProvider>
    )
}       